import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import { Flex, Box } from "sprout-ui-primitives";
import { Button } from "sprout-ui-dom/dist/Button";
import { NotificationsNoneOutlined, Notifications, ArrowBackIosOutlined } from "sprout-ui-icons";
import styled from "styled-components";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import { Sprout } from "sprout-ui-dom/dist/Sprout";
import { useBus } from "sprout-ui-dom/dist/Bus";
import { TooltipShortcut } from "sprout-ui-dom/dist/Tooltip";
import { Link, useLocation } from "react-router-dom";
import { useGoBack } from "@sprout/providers/dist/goBack";
import { useIsWelcomePageOnboard } from "@sprout/hooks/dist/onboard";
import { media, themeGet } from "sprout-ui-theme";
import { stringify } from "query-string";
import BaseBadge from "../../../Badge";
import AppBarSearch from "../../AppBar_Search";
import AppBarSearchButton from "../../AppBar_Search/AppBar_Search_Button";
import AppBarDesktop from "../../styles/AppBar_Desktop";
import AppBarNavList from "../../styles/AppBarNavList";
import AppBarAppDesktopButton from "./AppBar_App_Desktop_Button";
import AppBarAppDesktopNav from "./AppBarAppDesktopNav";
import AppBarAppDesktopAppMoreMenu from "./AppBarAppDesktopAppMoreMenu";
const AppBarNotificationsButton = styled(AppBarAppDesktopButton)`
  color: ${themeGet("colors.black.87")};
`;
const Badge = styled(BaseBadge)`
  position: absolute;
  top: 5px;
  right: 5px;
`;
const GoBackButton = styled(Button)`
  width: 36px;
  height: 36px;
  box-shadow: 0 1px 20px rgba(0, 0, 0, 0.1);

  background: ${themeGet("colors.blue.40")};

  :not(:disabled) {
    ${media.target("pointer")} {
      :hover {
        background: #f7fafd;
      }
    }

    :active {
      background: #f7fafd;
    }
  }
`;
const AppBarApp = ()=>{
    var ref;
    const currentUser = useCurrentUser();
    const unreadNotificationCount = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.unreadNotificationCount) || 0;
    const eventBus = useBus();
    const handleSignUpClick = useCallback(()=>{
        eventBus.emit("dialog::auth::open");
    }, [
        eventBus
    ]);
    const { pathname  } = useLocation();
    const startPage = currentUser === null || currentUser === void 0 ? void 0 : (ref = currentUser.userSetting) === null || ref === void 0 ? void 0 : ref.startPage;
    const { goBack  } = useGoBack();
    const renderBackButton = useMemo(()=>{
        return pathname !== startPage ? /*#__PURE__*/ _jsx(Flex, {
            alignItems: "center",
            mr: 2,
            children: /*#__PURE__*/ _jsx(GoBackButton, {
                variant: "circle",
                color: "black.87",
                onClick: goBack,
                children: /*#__PURE__*/ _jsx(ArrowBackIosOutlined, {})
            })
        }) : null;
    }, [
        goBack,
        pathname,
        startPage
    ]);
    const [isWelcomePageOnboard] = useIsWelcomePageOnboard();
    if (currentUser && !isWelcomePageOnboard) return null;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: currentUser ? /*#__PURE__*/ _jsxs(AppBarDesktop, {
            height: "56px",
            pl: "16px",
            pr: "4px",
            maxWidth: "1232px",
            mx: "auto",
            children: [
                /*#__PURE__*/ _jsxs(Flex, {
                    flex: "1",
                    justifyContent: "flex-start",
                    children: [
                        renderBackButton,
                        /*#__PURE__*/ _jsx(Box, {
                            my: "auto",
                            maxWidth: "220px",
                            children: /*#__PURE__*/ _jsx(AppBarSearch, {})
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(AppBarAppDesktopNav, {}),
                /*#__PURE__*/ _jsxs(Flex, {
                    flex: "1",
                    justifyContent: "flex-end",
                    children: [
                        /*#__PURE__*/ _jsxs(Box, {
                            position: "relative",
                            children: [
                                unreadNotificationCount > 0 && /*#__PURE__*/ _jsx(Badge, {
                                    children: unreadNotificationCount
                                }),
                                /*#__PURE__*/ _jsx(TooltipShortcut, {
                                    label: "Notifications",
                                    keys: [
                                        "g",
                                        "n"
                                    ],
                                    children: /*#__PURE__*/ _jsx(AppBarNotificationsButton, {
                                        url: "/notifications",
                                        children: (match)=>match ? /*#__PURE__*/ _jsx(Notifications, {}) : /*#__PURE__*/ _jsx(NotificationsNoneOutlined, {})
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(AppBarAppDesktopAppMoreMenu, {})
                    ]
                })
            ]
        }) : /*#__PURE__*/ _jsxs(AppBarDesktop, {
            height: "56px",
            px: "16px",
            maxWidth: "1232px",
            mx: "auto",
            children: [
                /*#__PURE__*/ _jsxs(Flex, {
                    flex: "1",
                    justifyContent: "flex-start",
                    children: [
                        renderBackButton,
                        /*#__PURE__*/ _jsx(Box, {
                            my: "auto",
                            width: "100%",
                            maxWidth: "220px",
                            children: /*#__PURE__*/ _jsx(AppBarSearchButton, {
                                onClick: handleSignUpClick
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Flex, {
                    alignItems: "center",
                    children: /*#__PURE__*/ _jsx(Sprout, {
                        url: "/"
                    })
                }),
                /*#__PURE__*/ _jsx(Flex, {
                    flex: "1",
                    justifyContent: "flex-end",
                    children: /*#__PURE__*/ _jsx("nav", {
                        children: /*#__PURE__*/ _jsxs(AppBarNavList, {
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        as: Link,
                                        to: {
                                            pathname: "/login",
                                            search: stringify({
                                                next: pathname
                                            })
                                        },
                                        "data-cy": "AppBar_LogIn",
                                        children: "Sign in"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        variant: "bright-blue",
                                        height: "48px",
                                        as: Link,
                                        to: {
                                            pathname: "/signup",
                                            search: stringify({
                                                next: pathname
                                            })
                                        },
                                        children: "Try it FREE"
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
export default AppBarApp;
